export default __webpack_public_path__ + "static/media/bg-feedback-1.51a36444.png";